import React from "react"
import { graphql } from "gatsby"

import Layout from "../components/layout"
import Portfolio from "../components/portfolio"

export default function Home({ data }) {

  const portfolioItems = data.allMarkdownRemark.nodes

  return <Layout>

    <div className="f4 f3-ns mt3 mb4 cf">

      <p className="measure-wide lh-title">
        We make maps, build interactive interfaces, and develop AI tools
        that help organizations understand, communicate, and act on their data.
      </p>

      <p className="f4">
        Say <a href="mailto:hello@picturedigits.com" className="link black dim underline">
          hello@picturedigits.com
        </a>.
      </p>

      <p className="f4">
        For US inquiries, contact <a href="mailto:jack@jackdougherty.org" className="link black dim underline">
          jack@jackdougherty.org
        </a>.
      </p>

    </div>

    <Portfolio
      items={portfolioItems}
    />

  </Layout>
}

export const query = graphql`
  query PortfolioGridQuery {
    allMarkdownRemark {
      nodes {
        frontmatter {
          title
          byline
          slug
          thumbnail
          pane
          order
        }
      }
    }
  }
`